export default "__VITE_ASSET__BxvkSaM1__"